import { Routes } from '@angular/router';

// Public routes
export const WEBVIEW_ROUTES: Routes = [
  {
    path: 'noticias',
    loadChildren: () => import('../../modules/news/news.module').then(m => m.NewsModule)
  }
];
